import {LeaderboardUser} from '@dms/api/settings';

import {getOperationGroupId} from './getOperationGroupId';
import {PayPerUseOperationColumn} from './getOperationTypeColumns';
import {isHiddenOperation} from './isHiddenOperation';

/**
 * Dense per-group count lookup for a user. A user's sparse `byOperationType`
 * entries are summed into their groups; columns the user has no entry for
 * resolve to 0.
 */
export const zeroFillUserOperationCounts = (
  user: LeaderboardUser,
  columns: PayPerUseOperationColumn[]
): Record<string, number> => {
  const totals = columns.reduce<Record<string, number>>((accumulator, column) => {
    accumulator[column.key] = 0;
    return accumulator;
  }, {});

  user.byOperationType.forEach((operation) => {
    if (isHiddenOperation(operation)) {
      return;
    }
    const groupId = getOperationGroupId(operation);
    if (groupId in totals) {
      totals[groupId] += operation.count;
    }
  });

  return totals;
};
